module.exports = __webpack_public_path__ + "static/media/icon_data-volume-issue.0bb4cdf0.svg";